import { useEffect, useState } from "react";
import { Modal, ModalBody } from "react-bootstrap";
import { ServerRequestProtected } from "../../../utils/ServerDataRequest";
import NotificationHandler from "../../../utils/NotificationHandler";
import { enumUtil } from "../../../utils/Enum";
import isNull from "../../../utils/NullChecking";
import Loader from "../../shared/Loader/Loader";
import AIEncounterTranscriptPreview from "../../Patient/PatientDetails/Encounter/Components/EncounterRightPortion/TemplateView/EncounterDetails/AIEncounterTranscriptPreview";
const ViewTestResults = (props) => {
    const { isViewResult, onClose, id, otherData } = { ...props }
    const [isLoading, setIsLoading] = useState(false)
    const API_URL = enumUtil.controller.AITool
    const [testResultsData, setTestResultsData] = useState(null)
    useEffect(() => {
        if (!isNull(id)) {

            setIsLoading(true)
            ServerRequestProtected(`${API_URL}/${id}`, 'GET'
            ).then((response) => {
                setIsLoading(false)
                setTestResultsData(response)
            }).catch((error) => {
                NotificationHandler(error.response.data, enumUtil.enumtoaster.error)
                setIsLoading(false)
                setTestResultsData(null)
            })
        }
    }, [id])
    console.log('testResultsData', testResultsData);
    const renderApiData = (data) => {
        if (!data || typeof data !== 'object') return null;

        const SECTION_ORDER = [
            'data',
            'assessment',
            'progress',
            'plan'
        ];

        const orderedKeys = [
            ...SECTION_ORDER.filter(key => key in data),
            ...Object.keys(data).filter(key => !SECTION_ORDER.includes(key))
        ];

        return orderedKeys.map((key) => (
            <div key={key} className="d-flex flex-column gap-6">
                <p className="heading text-capitalize lh-1">
                    {key.replace(/_/g, ' ')}
                </p>

                <p className="text fs-12 lh-normal">
                    {data[key] || 'N/A'}
                </p>
            </div>
        ));
    };
    // const renderTranscript = (transcript) => {
    //     if (!transcript) return null;

    //     const lines = transcript
    //         .split('\\n')
    //         .map(line => line.trim())
    //         .filter(line => line.length > 0);

    //     return (
    //         <div className="transcript-container d-flex flex-column gap-1">
    //             {lines.map((line, index) => (
    //                 <p key={index} className="text">{line}</p>
    //             ))}
    //         </div>
    //     );
    // };

    const ASAM_LABELS = {
        // Dimension 1
        addiction_medications: "Are you using any medications for withdrawals or cravings?",
        sobriety_from_doc: "How long have you been sober from your DOC?",
        sobriety_from_all_substances: "How long have you been sober from all substances?",
        current_withdrawal_symptoms: "Are you currently experiencing any withdrawal symptoms such as tremors, sweating, rapid heart rate, anxiety, nausea, etc?",
        history_of_severe_withdrawal: "Do you have a history of serious withdrawals such as seizures, or anything else health-threatening?",
        history_of_overdose: "Do you have a history of overdose? When was the last time you overdosed?",

        // Dimension 2
        primary_care_and_medical_visits: "Do you have a primary doctor? When was the last time you saw a medical provider?",
        medications_and_adherence: "Are you currently taking any medications? Are you taking them as prescribed?",
        medical_conditions_affecting_treatment: "Do you have any known medical conditions at this time, particularly any that could be a distraction from treatment?",
        pregnancy_or_sleep_concerns: "Any issues with pregnancy or sleep that need immediate attention?",
        physical_health_goals: "What goals do you have for your physical health or medical conditions? What changes could you start making to make this possible for you?",

        // Dimension 3
        self_harm_history: "Do you have any history of self harm? When was the last time? What was it?",
        mental_health_treatment_history: "Have you previously received treatment for mental health or emotional problems? When was the last time?",
        depression_anxiety_ptsd_symptoms: "Assess depression and anxiety and PTSD with scales. Currently/last seven days. Does it stay pretty consistent?",
        coping_skills_and_supports: "What helps you cope with your anxiety and/or depression/PTSD?",
        psychosis_or_cognitive_symptoms: "Are you experiencing any current psychosis such as paranoia, delusions, or any confusion?",
        suicidal_ideation_history: "Do you have any history of suicidal ideations? When was the last time?",
        recent_thoughts_of_death_or_hopelessness: "Have you had thoughts that you would be better off dead in the last 30 days?",
        mental_health_medications: "Are you currently taking any medications for your mental health? What are they for?",

        // Dimension 4
        awareness_of_substance_use_impact: "Do you think you need treatment to change your use of substances?",
        belief_in_need_for_treatment: "Do you believe changing your use of substances could improve any aspects of your life? Which ones?",
        past_treatment_effectiveness: "How helpful has treatment been in the past?",
        desire_to_quit_or_reduce_use: "Do you want to quit or cut back your alcohol or other drug use?",

        // Dimension 5
        factors_supporting_sobriety: "What helped you go that long without using alcohol and/or other drugs?",
        support_system: "Who makes up your support system?",
        current_cravings_level: "Current Cravings 0-10, 10 being the highest",
        sobriety_duration_longest_period: "What is the longest period of time that you have gone without using alcohol and/or other drugs?",
        environmental_relatapse_factors: "If you relapsed in the past, what environmental things led to your relapse?",
        recent_triggers_or_stressors: "Which trigger(s) or problem(s) have been the worst for you in the past month or so?",
        safety_of_current_relationships: "Do any of your current relationships pose a threat to your safety or recovery?",
        potential_risks_if_no_treatment: "What problems could happen or get worse if you do not get help now?",

        // Dimension 6
        housing_stability: "In the past two months, have you been living in stable housing that you own, rent, or stay in as part of a household?",
        financial_stability: "What are the sources of your financial support?",
        supportive_individuals: "Are these sources providing you with financial stability?",
        clinical_justification: "clinical_justification",
        future_housing_concerns: "Are you worried or concerned that in the next two months you may NOT have stable housing that you own, rent, or stay in as part of a household?",
        employment_or_education_status: "Are you working/going to school/retired/disabled/unemployed?",
        financial_support_sources: "Who else in your life cares whether you quit or not?",
        barriers_to_treatment: "Do you have any concerns or fears that make it hard for you to stay in treatment?",
        leisure_and_free_time: "How do you prefer to spend your free time (e.g., when not working)?",
        desired_environment_changes: "If things improved in your environment, what would that look like?",
        environment_goals: "What are your top environment goals? This might include getting a job, going back to school, getting social services, etc",
        recommended_level_of_care: "Clinically Recommended Level of Care Based on Above Assessment",
    };

    // Format dimension key: "dimension_1" → "Dimension 1"
    const formatDimensionKey = (key) => {
        return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    };

    // Format section key: "withdrawal_intoxication_medication_assessment" → "Withdrawal Intoxication Medication Assessment"
    const formatSectionKey = (key) => {
        return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    };

    const renderASAMData = (data) => {
        if (!data || typeof data !== 'object') return null;

        const sortedEntries = Object.entries(data).sort(([keyA], [keyB]) => {
            const numA = parseInt(keyA.match(/\d+/)?.[0] ?? 0, 10);
            const numB = parseInt(keyB.match(/\d+/)?.[0] ?? 0, 10);
            return numA - numB;
        });

        return sortedEntries.map(([dimensionKey, dimensionValue]) => (
            <div key={dimensionKey} className="d-flex flex-column gap-2">
                <p className="heading fs-13 text-decoration-underline">
                    {formatDimensionKey(dimensionKey)}
                </p>
                {typeof dimensionValue === 'object' && dimensionValue !== null &&
                    Object.entries(dimensionValue).map(([sectionKey, sectionValue]) => (
                        <div key={sectionKey} className="d-flex flex-column gap-6">
                            <p className="heading fs-12">
                                {formatSectionKey(sectionKey)}
                            </p>
                            {typeof sectionValue === 'object' && sectionValue !== null
                                ? Object.entries(sectionValue).map(([fieldKey, fieldValue]) => (
                                    <div key={fieldKey} className="d-flex flex-column gap-1">
                                        <p className="heading">{ASAM_LABELS[fieldKey] || formatSectionKey(fieldKey)}</p>
                                        {typeof fieldValue === 'object' && fieldValue !== null
                                            ? Object.entries(fieldValue).map(([k, v]) => (
                                                <p key={k} className="text">
                                                    <span className="heading text-capitalize">{k.replace(/_/g, ' ')}: </span>
                                                    {v}
                                                </p>
                                            ))
                                            : <p className="text fs-11">{fieldValue || 'N/A'}</p>
                                        }
                                    </div>
                                ))
                                : <p className="text fs-11">{sectionValue || 'N/A'}</p>
                            }
                        </div>
                    ))
                }
            </div>
        ));
    };
    return (
        <Modal show={isViewResult} onHide={onClose} backdrop="static" keyboard={false} centered dialogClassName=" hk-modal-v1 ar-propmt-result-popup">
            {isLoading ? <Loader /> : null}
            <Modal.Body>
                <div class="d-flex justify-content-between align-items-center mt-2 mb-10 hk-modal-header px-10">
                    <p class="heading">Result</p>
                    <i class="icon-x-cros fs-20 fs-20 dark-clr" onClick={onClose}></i>
                </div>

                <div className="d-flex gap-12  px-10">
                    <div className="d-flex flex-column gap-2 scroll-content w-50">
                        <p className='heading text-decoration-underline fs-13 stickey-content text-black'>Transcript</p>
                        <div className='d-flex flex-column gap-1'>
                            {otherData?.Transcript && otherData?.Transcript.split('\n').map((line, index) => {
                                const parts = line.replace(/\\b/g, '\b').split('\b');
                                if (parts.length > 1) {
                                    const Speaker = parts[0];
                                    const message = parts.slice(1).join('');
                                    return (
                                        <p key={index} className="text lh-normal">
                                            {Speaker && <span className="font-sb">{Speaker}</span>} {message}
                                        </p>
                                    );
                                } else {
                                    return (
                                        <p key={index} className="text lh-normal">{line}</p>
                                    );
                                }
                            })}
                        </div>
                    </div>
                    <div className="d-flex flex-column gap-2 scroll-content w-50 br-left-1 za_br_light ps-12">
                        <p className='heading text-decoration-underline fs-13 stickey-content text-black'>Result</p>

                        <div className="d-flex flex-column gap-15 flex-shrink-0">

                            {testResultsData &&
                                <AIEncounterTranscriptPreview generatedNotes={{ MainCustomTemplate: testResultsData?.FormData || [] }} />}
                            {/* {otherData?.NoteType?.toLowerCase().includes('asam') ?
                                renderASAMData(testResultsData)
                                : renderApiData(testResultsData)
                            } */}
                        </div>
                    </div>
                </div>
            </Modal.Body>
            <div className="d-flex align-items-center pb-15 px-10 pt-2 br-top-1 za_br_light justify-content-end gap-2 ar_footer">
                <button className='btn btn-validate  px-10 h-100' onClick={onClose}>Close</button>
            </div>
        </Modal>
    )
}

export default ViewTestResults